var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div"),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "vxe-table",
            { attrs: { "row-id": "id", data: _vm.table, align: "left" } },
            [
              _c("vxe-table-column", {
                attrs: {
                  field: "dev_name",
                  "show-overflow": "",
                  "min-width": "80",
                  title: "设备名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "product_name",
                  "show-overflow": "",
                  "min-width": "120",
                  title: "所属产品",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "group_name",
                  "show-overflow": "",
                  "min-width": "120",
                  title: "所在分组",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "created_at_str",
                  "show-overflow": "",
                  "min-width": "120",
                  title: "创建时间",
                },
              }),
              _c("vxe-column", {
                attrs: { title: "操作", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (slotProps) {
                      return [
                        _c(
                          "span",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "S",
                                  type: "text",
                                  name: "btn-text1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openViewModel(slotProps.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v("查看")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "S",
                                  type: "text",
                                  name: "btn-text1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelModel(slotProps.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v("从分组中删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.total
        ? _c("v-pagination", {
            attrs: {
              total: _vm.total,
              name: "page-basic",
              "is-show-total": "",
              "is-change-size": "",
              "is-input-page": "",
              "current-page": this.currentPage,
            },
            on: {
              "change-page": _vm.changePage,
              "change-size": _vm.changeSize,
            },
          })
        : _vm._e(),
      _c("RemoveGroup", {
        ref: "RemoveGroup",
        attrs: { showInputDialog: _vm.RemoveGrouploading, devId: _vm.devId },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.RemoveGrouploading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.RemoveGrouploading = $event
          },
          getData: _vm.getData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }